/*
 * Copyright (c) 2023 - 2026. Bluemate B.V.
 */
import './style/bluemateSearchInput.scss';

import {Icon} from '@iconify/react';

import classNames from 'classnames';

import {ElementPosition, OrnamentShape} from '@dvrd/dvr-controls';

import InputController, {InputProps} from '../input/inputController';

type Props = Omit<InputProps, 'value' | 'ornaments' | 'shape' | 'clearable' | 'area' | 'date'> & {
    value?: string;
};

const SEARCH_ORNAMENT: OrnamentShape = {placement: ElementPosition.LEFT, element: <Icon icon='mdi:magnify' />};

export default function BluemateSearchInput(props: Props) {
    const {value = '', placeholder = 'Zoeken...', className, ...rest} = props;

    return (
        <InputController
            {...rest}
            value={value}
            placeholder={placeholder}
            className={classNames('bluemate-search-input-container', className)}
            shape='rounded'
            ornaments={SEARCH_ORNAMENT}
            clearable
        />
    );
}
